import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6b481a06&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b481a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b481a06')) {
      api.createRecord('6b481a06', component.options)
    } else {
      api.reload('6b481a06', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6b481a06&scoped=true&", function () {
      api.rerender('6b481a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/Accordion.vue"
export default component.exports